/*Tps-report*/
if (window.location.pathname.includes("crm/vendor/")) {
    $(window).on("/api/note/create.success", function(e, response, form){
        form[0].reset();
        $('select[name="note_type_id"]').val('').trigger('change').trigger('change');
        $('select[name="status"]').val('').trigger('change').trigger('change');
        window.app_data.leave_note = '';
        app.vendor.notes.unshift(response['note']);
    });

    $("#branches-table").data("options", app_data.datatables.branches.options);
    $("#placements-table").data("options", app_data.datatables.placements.options);

    $(window).on('popup_open', function (e, type, data) {
        if (type === 'editor-crm_alerts' && typeof data !== 'undefined') {
            if (!data.isEdit) return;

            const pop = $('.popup[data-type="editor-crm_alerts"]');

            if (!data.response) return;

            pop.find('[name="user_id"]')
                .append('<option value="' + data.response.user.id + '">' + data.response.user.name + '</option>')
                .val(data.response.user_id.toString())
                .trigger("change")
                .trigger("change");
            pop.find('[name="alert_template_id"]')
                .append('<option value="' + data.response.template.id + '">' + data.response.template.name + '</option>')
                .val(data.response.alert_template_id.toString())
                .trigger("change")
                .trigger("change");
        }
    });

    const alert_options = {
        "columnDefs": [
            {
                targets: 0,
                createdCell: function (td, cellData, rowData, row, col) {
                    if (moment(row.reminder_date).isBefore(moment())) {
                        $(td).css('background-color', '#f5c6cb');
                    }
                }
            },
        ]
    };

    $('#crm_alerts').data('options', alert_options);

    $(window).on("/api/alert/create.success", function(e, response) {
        const table = $("#crm_alerts");
        table.DataTable().destroy();
        table.data("options", alert_options);
        window.dataTableInstance(table);
    });

    $(window).on("/api/vendor/assign.success", (e, response, form) => {
        popup_close("editor-assign_office");

        const table = $("#branches-table");
        table.DataTable().destroy();
        window.dataTableInstance(table);
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/vendor.js